<div class="flex flex-row items-stretch content-wrapper" cslPerfectScrollbar>
  <div class="cutout-list-wrapper overflow-auto basis-200 max-w-screen-md" cslPerfectScrollbar>
    <csl-cutouts-creator
      class="block w-full max-w-full"
      [panelHeight]="tempCountertop.length"
      [panelWidth]="tempCountertop.width"
      [schema]="schema"
      (cutoutChanged)="formChangeHandler($event)"
      (statusChange)="stateChanged$.next($event === 'VALID')"></csl-cutouts-creator>
  </div>

  <div class="basis-96 min-w-96 flex-auto" cslPerfectScrollbar>
    <div class="w-full h-full overflow-hidden">
      <csl-countertop-schema></csl-countertop-schema>
    </div>
  </div>
</div>
